import styled from 'styled-components'

import PropTypes from 'prop-types'

export const Container = styled.div`
  background: ${props => props.theme.foreground};
  border-radius: 4px;
  padding: 0 1rem;
  padding-top: 8px;
  height: 4rem;

  margin-bottom: 1rem;

  display: ${(props) => (props.hidden ? 'none' : 'flex')};
  opacity: ${(props) => (props.isDisabled ? 0.65 : 1)};
  position: relative;
  align-items: center;

  color: ${(props) => props.theme.text};

  &,
  * {
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'initial')};
  }

  & + & {
    margin-top: 0.5rem;
  }

  label {
    position: absolute;
    top: 4px;
    left: 1rem;
    font-size: 10px;
    color: inherit;
    transition: opacity 0.5s;
    opacity: 1; // ${(props) => Number(props.isFocused || props.isFilled)}
  }

  input {
    color: ${(props) => props.theme.text};
    background: transparent;
    padding: 0.75rem 0 0.75rem 0;

    flex: 1;
    height: 100%;
    width: 100%;

    &::placeholder {
      color: ${(props) => props.theme.textLight};
      transition: color 0.25s ease-in;
      opacity: 0.75;
    }

    &:focus::placeholder {
      color: transparent;
    }
  }

  > svg {
    margin-right: 1rem;
  }
`

Container.propTypes = {
  isFocused: PropTypes.bool,
  isFilled: PropTypes.bool,
  hasError: PropTypes.bool
}

export const Error = styled.span`
  position: absolute;
  bottom: -14px;
  color: ${(props) => props.theme.danger};
  font-size: 10px;
`
Error.propTypes = {
  isFocused: PropTypes.bool
}
